const styles = {
  root: {
    paddingBottom: 80,
    height: '100vh',
    overflow: 'auto',
    boxSizing: 'border-box',
    '& .floating-action': {
      backgroundColor: '#fff',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      paddingBottom: 8,
      paddingTop: 8,
      boxShadow: '-1px -1px 4px rgba(0, 0, 0, 0.04)',
      border: '1px solid #F3F3F3',
    },
  },
};

export default styles;
